/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Tabs — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: indicator backgroundColor → NS interactive token (mode-aware) i.p.v.
// palette.secondary.main. minHeight 48 (MUI default) blijft. transition: none op
// indicator/scrollButtons (ground-rules.md "Motion and text": geen animatie).

export const MuiTabsLightOverrides = {
  // Tractie TRACTIE Tabs has a full-width hairline divider (border/default)
  // under the row, with the active indicator sitting on top. border-box keeps
  // the row at 48px despite the 1px border.
  root: {
    overflow: 'hidden' as const,
    minHeight: 48,
    boxSizing: 'border-box' as const,
    borderBottom: '1px solid var(--ns-color-border-default)',
    WebkitOverflowScrolling: 'touch' as const,
    display: 'flex' as const,
  },

  vertical: {
    flexDirection: 'column' as const,
  },

  flexContainer: {
    display: 'flex' as const,
  },

  flexContainerVertical: {
    flexDirection: 'column' as const,
  },

  centered: {
    justifyContent: 'center' as const,
  },

  scroller: {
    position: 'relative' as const,
    display: 'inline-block' as const,
    flex: '1 1 auto',
    whiteSpace: 'nowrap' as const,
  },

  fixed: {
    overflowX: 'hidden' as const,
    width: '100%',
  },

  scrollable: {
    overflowX: 'scroll' as const,
  },

  scrollButtons: {
    transition: 'none',
  },

  scrollButtonsDesktop: {},

  indicator: {
    backgroundColor: 'var(--ns-color-bg-interactive-default)',
    transition: 'none',
  },
} as const;

// Dark variant — token --ns-color-bg-interactive-default is mode-aware via tokens.css.
export const MuiTabsDarkOverrides = {
  ...MuiTabsLightOverrides,
} as const;
